import { inject } from '@angular/core';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
export class AgentPromptListService {
    constructor() {
        this.ajaxService = inject(AjaxService);
        this.urlsService = inject(UrlsService);
    }
    getAgentPrompts(getParams) {
        const url = this.urlsService.AGENT.PROMPT_LIST_COLLECTION;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.ajaxService.getDataObserveBody(url, {
            ...getParams,
            tz,
        });
    }
    getAgentPrompt(agentPromptId) {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DETAIL, { agentPromptId });
        return this.ajaxService.getDataObserveBody(url);
    }
    createAgentPrompt(body) {
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.AGENT.PROMPT_LIST_COLLECTION, body);
    }
    updateAgentPrompt(agentPromptId, body) {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DETAIL, { agentPromptId });
        return this.ajaxService.putJsonDataObserveBody(url, body);
    }
    duplicateAgentPrompt(agentPromptId) {
        const url = this.urlsService.getUrl(this.urlsService.AGENT.PROMPT_DUPLICATE, { agentPromptId });
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
}
AgentPromptListService.ɵfac = function AgentPromptListService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentPromptListService)(); };
AgentPromptListService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentPromptListService, factory: AgentPromptListService.ɵfac, providedIn: 'root' });
